import styled from 'styled-components';

export const Content = styled.div`
  padding: ${({ theme }) => `${theme.spacing(8)} ${theme.spacing(6.5)}`};

  overflow: auto;
`;
